import React from "react";
import ModalLayout from "../..";
import "./style.scss";

interface RemarksProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onConfirm: () => void;
  remarkText?: string;
}

const Remarks: React.FC<RemarksProps> = ({
  open,
  onClose,
  onConfirm,
  title = "heading test",
  remarkText,
}) => {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      secondaryBtnText=""
      closeBtnText=""
    >
      <div className="remarks-wrapper rounded-[10px] p-4">
        <div className="header-wrapper pb-[12px]  ">
          <p className="description">{remarkText}</p>
        </div>
      </div>
    </ModalLayout>
  );
};

export default Remarks;
